<template>
	<div
		class="position-absolute package-info-container text-grey-900 caption text-wrap d-none d-md-flex font-size-12 line-height-14 py-2 d-flex flex-column justify-content-center position-absolute"
		:style="{
			top: props.top,
			...(props.right ? { right: props.right } : { left: props.left }),
			'border-radius': props.radius,
		}">
		<slot></slot>
	</div>
</template>

<script lang="ts" setup>
interface Props {
	top?: string
	left?: string
	radius?: string
	right?: string
}

const props = withDefaults(defineProps<Props>(), {
	top: "30px",
	left: "30px",
	radius: "5px",
})
</script>

<style scoped>
.package-info-container {
	visibility: hidden;
	justify-content: center;
	padding: 10px 20px;
	gap: 5px;
	z-index: 1;
	width: 396px;
	/* height: 81px; */
	background: #ffffff;
	border: 1px solid #dee2e6;
	box-shadow: 0px 1px 8px rgba(16, 24, 40, 0.1),
		0px 1px 3px rgba(16, 24, 40, 0.1);
}
.package-info-container:hover {
	visibility: visible;
}
</style>
